import React from 'react';
import Steps from '../components/steps.js';
import { Helmet } from "react-helmet-async";


const Revisor = () => {

  return (
    <div>
      <Helmet>
        <title>Revisão de Aposentadoria: Calculadora e Análise de Erros INSS</title>
        <meta
          name="description"
          content="Será que sua aposentadoria foi calculada errado? O INSS pode ter errado no seu valor. Faça uma análise de cálculo online agora e descubra se você tem direito a receber valores atrasados."
        />
        <meta
          name="keywords"
          content="revisão de aposentadoria, calcular revisão inss online, erro no cálculo do benefício, revisão de aposentadoria ainda vale a pena, valor retroativo inss"
        />

        <meta property="og:title" content="Você pode estar perdendo dinheiro todo mês — e nem sabe" />
        <meta
          property="og:description"
          content="Mais de 60% das aposentadorias têm erro no valor. Descubra em poucos minutos se o seu benefício está abaixo do correto."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://revisajaaposentadoria.com.br/revisao" />
        <meta property="og:image" content="https://revisajaaposentadoria.com.br/og-revisao.png" />

        <link rel="canonical" href="https://revisajaaposentadoria.com.br/revisao" />
      </Helmet>

      <Steps />
    </div>
  );
};

export default Revisor;